const translation = {
  PROMOTION_VALUE_OFF_PERCENTAGE:
    "احصل علي خصم {{value}} % وحتي {{maximum}} {{currency}}. بحد اقصي {{times}} رحلات",
  PROMOTION_VALUE_OFF_AMOUNT:
    "احصل علي خصم {{value}} {{currency}} وحتي {{maximum}} {{currency}}. بحد اقصي {{times}} رحلات",
  PROMOTION_VALUE_PERCENTAGE:
    "احصل علي خصم {{100-value }} %  وحتي {{maximum}} {{currency}}. بحد اقصي {{times}} رحلات",
  PROMOTION_VALUE_AMOUNT:
    "ادفع {{value}} {{currency}} فقط وحتي {{maximum}} {{currency}}. بحد اقصي {{times}} رحلات!",
};
export default translation;



// WEBPACK FOOTER //
// ./src/i18n/ar.js